import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../contexts/CartContext';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { auth } from './../../firebase/firebaseConfig';
import { Menu, MenuItem, IconButton } from '@mui/material';
import logo from './../images/7.png';
import './../css/NavBar.css';

import { fetchCategories } from './../contexts/categoryService'; // Adjust the import path

import { FavoriteContext } from './../contexts/FavoriteContext'; // Adjust the import based on your file structure
import { addFavorite, removeFavorite, isFavorite } from './../../firebase/favoriteHelpers'; // Updated import path
import SearchModal from './SearchModal';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));

export default function NavBar() {
  const { cartSummary } = useContext(CartContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isFav, setIsFav] = useState(false); // Add state for favorites
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const currentUser = auth.currentUser;

  useEffect(() => {
    // Check if the product is a favorite when the component mounts
    (async () => {
      if (currentUser) {
        const fav = await isFavorite('product-id', currentUser); // Replace 'product-id' with the actual product ID
        setIsFav(fav);
      }
    })();
  }, [currentUser]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    auth.signOut().then(() => {
      handleClose();
      navigate('/sign-in'); // Redirect to sign-in page after logout
    }).catch((error) => {
      console.error(error);
    });
  };

  const handleFavoriteClick = async () => {
    if (isFav) {
      await removeFavorite('product-id', currentUser); // Replace 'product-id' with the actual product ID
      setIsFav(false);
    } else {
      await addFavorite('product-id', currentUser); // Replace 'product-id' with the actual product ID
      setIsFav(true);
    }
  };

  const renderNavigation = () => {
    if (currentUser) {
      return (
        <>
          <IconButton
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <svg stroke="currentColor" fill="white" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M13 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM3.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM8 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0z" clipRule="evenodd"></path>
            </svg>
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
            sx={{
              mt: '4vh', // Adjust vertical margin from the anchor element
              '& .MuiPaper-root': {
                minWidth: '150px', // Adjust width
                padding: '10px', // Adjust padding for larger menu items
              }
            }}
          >
            <MenuItem onClick={handleClose}>
              <Link to="/profile" style={{ textDecoration: 'none', color: 'inherit' }}>Profile</Link>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <Link to="/settings" style={{ textDecoration: 'none', color: 'inherit' }}>Settings</Link>
            </MenuItem>
            <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
          </Menu>
        </>
      );
    } else {
      return (
        <Link to="/sign-in" className="mx-2" style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
          <svg stroke="currentColor" fill="white" strokeWidth="0" viewBox="0 0 16 16" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M13 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM3.022 13h9.956a.274.274 0 00.014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 00.022.004zm9.974.056v-.002.002zM8 7a2 2 0 100-4 2 2 0 000 4zm3-2a3 3 0 11-6 0 3 3 0 016 0z" clipRule="evenodd"></path>
          </svg>
        </Link>
      );
    }
  };

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const fetchedCategories = await fetchCategories();
        setCategories(fetchedCategories);
      } catch (error) {
        console.error("Error fetching categories: ", error);
      }
    };

    getCategories();
  }, []);


  //for the favorite button icon
  const { favorites } = useContext(FavoriteContext);
  return (
    <>
      <div className="main-nav fixed-top">
        <div className="top-nav">

          <div className="logo-container">
            <Link to="/" style={{ textAlign: "center" }}>
              <img src={logo} className="brand-logo" alt="ALMOSTINVISIBLE LOGO" />
            </Link>
          </div>

          <div className="icons-container d-flex align-items-center">
            
            {/** search icon */}
            <button type="button" className='mx-2' style={{ width: "fit-content" }} data-bs-toggle="modal" data-bs-target="#searchModal">
              <svg stroke="currentColor" fill="white" strokeWidth="0" viewBox="0 0 1024 1024" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
                <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
              </svg>
            </button>


              {/** Favorite Icon */}
              <Link
              aria-label="favorites"
              to="/favorites"
              color="inherit"
              className="mx-2 mt-2"
            >
              <Badge badgeContent={favorites.length} sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: 'white',
                  color: 'black',
                  fontWeight: 'bold'
                },
              }}>
                  <svg stroke="currentColor" fill="white" strokeWidth="0" viewBox="0 0 1024 1024" height="1.7em" width="1.7em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                  </svg>
              </Badge>
              </Link>

              {/** cart icon */}
              <Link to="/cart" className='mx-2'>
                <Badge badgeContent={cartSummary.totalItems} sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: 'white',
                    color: 'black',
                    fontWeight: 'bold'
                  },
                }}>
                  <svg stroke="currentColor" fill="white" strokeWidth="0" viewBox="0 0 16 16" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z" clipRule="evenodd"></path>
                    <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z"></path>
                  </svg>
                </Badge>
              </Link>

              <div className="per-son">
                {renderNavigation()}
              </div>


          </div>
        </div>
        <div className="bottom-nav">
          <div>
            {categories.map(category => (
              <Link to={`/products/${encodeURIComponent(category.name)}`} className="link" key={category.id}>
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <SearchModal />
    </>
  );
}
